import { Link } from "react-router-dom";

export default function HomeThreeBlog(){
    return(
        <>
            <section id="news" className="grey-bg blog-area blog-area-3 pt-115 pb-90 pt-md-60 pb-md-30 pt-xs-60 pb-xs-30">
			<div className="container">
				<div className="row">
					<div className="col-lg-12">
						<div className="section-title text-center mb-60">
							<p className="mb-10">News</p>
							<h2 className="sect-title text-heding3">Blog & Insights</h2>
						</div>
					</div>
				</div>
				<div className="row">
					<div className="col-lg-6">
						<div className="blogs-2 mb-30">
							<div className="blogs__thumb">
								<Link to="/news-details">
									<img src="assets/img/blog/blog-9.jpg" alt="Blog Img" />
								</Link>
							</div>
							<span className="tag">IT Solution</span>
							<div className="blogs__content">
								<span className="fs-14 text-white"><i className="fal fa-calendar-alt"></i> 24th June 2022</span>
								<h3><Link className="text-white fs-20" to="/news-details">Improving lives with technology
										– HSE
										lighthouse project is automotive has sought to change the way.</Link></h3>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="blogs mb-30">
							<div className="blogs__thumb">
								<Link to="/news-details">
									<img className="w-100" src="assets/img/blog/blog-1.jpg" alt="Blog Img" />
								</Link>
							</div>
							<span className="tag">IT Solution</span>
							<div className="blogs__content">
								<p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
								<h5><Link className="blog-title text-heding3" to="/news-details">Technology support
										allows erie non-profit to serve</Link></h5>
							</div>
						</div>
					</div>
					<div className="col-lg-3 col-md-6">
						<div className="blogs mb-30">
							<div className="blogs__thumb">
								<Link to="/news-details">
									<img className="w-100" src="assets/img/blog/blog-1.jpg" alt="Blog Img" />
								</Link>
							</div>
							<span className="tag">IT Solution</span>
							<div className="blogs__content">
								<p><i className="fal fa-calendar-alt"></i> June 21, 2022</p>
								<h5><Link className="blog-title text-heding3" to="/news-details">Technology support
										allows erie non-profit to serve</Link></h5>
							</div>
						</div>
					</div>
				</div>
			</div>
		</section>
        </>
    )
}